/**
 * Custom Select Dropdown for Gravity Forms
 * Creates a custom styled select with arrow positioned next to text
 */

document.addEventListener('DOMContentLoaded', function() {
    // Find all Gravity Forms select elements
    const selectElements = document.querySelectorAll('.gform_wrapper select');
    
    selectElements.forEach(function(select) {
        // Skip if already processed
        if (select.classList.contains('custom-select-processed')) {
            return;
        }
        
        // Create wrapper div
        const wrapper = document.createElement('div');
        wrapper.className = 'custom-select-wrapper';
        
        // Create the custom select display
        const customSelect = document.createElement('div');
        customSelect.className = 'custom-select-display';
        customSelect.setAttribute('tabindex', '0');
        customSelect.setAttribute('role', 'combobox');
        customSelect.setAttribute('aria-label', 'Select an option');
        customSelect.setAttribute('aria-expanded', 'false');
        customSelect.setAttribute('aria-haspopup', 'listbox');
        customSelect.innerHTML = `
            <span class="custom-select-text">${select.options[select.selectedIndex]?.text || 'Select an option'}</span>
            <span class="custom-select-arrow">▼</span>
        `;
        
        // Create dropdown list
        const dropdown = document.createElement('div');
        dropdown.className = 'custom-select-dropdown';
        dropdown.setAttribute('role', 'listbox');
        
        // Populate dropdown with options
        Array.from(select.options).forEach(function(option, index) {
            const optionElement = document.createElement('div');
            optionElement.className = 'custom-select-option';
            optionElement.setAttribute('role', 'option');
            optionElement.setAttribute('tabindex', '-1');
            optionElement.setAttribute('aria-label', option.text);
            optionElement.textContent = option.text;
            optionElement.dataset.value = option.value;
            optionElement.dataset.index = index;
            
            if (option.selected) {
                optionElement.classList.add('selected');
                optionElement.setAttribute('aria-selected', 'true');
            }
            
            optionElement.addEventListener('click', function() {
                // Update the original select
                select.selectedIndex = index;
                select.dispatchEvent(new Event('change'));
                
                // Update display
                customSelect.querySelector('.custom-select-text').textContent = option.text;
                
                // Update selected state
                dropdown.querySelectorAll('.custom-select-option').forEach(opt => opt.classList.remove('selected'));
                optionElement.classList.add('selected');
                
                // Close dropdown
                wrapper.classList.remove('open');
            });
            
            dropdown.appendChild(optionElement);
        });
        
        // Insert wrapper before select and move select inside
        select.parentNode.insertBefore(wrapper, select);
        wrapper.appendChild(select);
        wrapper.appendChild(customSelect);
        wrapper.appendChild(dropdown);
        
        // Hide original select
        select.style.display = 'none';
        
        // Toggle dropdown
        customSelect.addEventListener('click', function(e) {
            e.stopPropagation();
            wrapper.classList.toggle('open');
            customSelect.setAttribute('aria-expanded', wrapper.classList.contains('open'));
        });
        
        // Keyboard navigation
        let selectedIndex = select.selectedIndex;
        
        customSelect.addEventListener('keydown', function(e) {
            const options = dropdown.querySelectorAll('.custom-select-option');
            
            switch(e.key) {
                case 'Enter':
                case ' ':
                    e.preventDefault();
                    if (wrapper.classList.contains('open')) {
                        // Select the highlighted option
                        const highlighted = dropdown.querySelector('.custom-select-option[aria-selected="true"]');
                        if (highlighted) {
                            highlighted.click();
                        }
                    } else {
                        // Open dropdown
                        wrapper.classList.add('open');
                        customSelect.setAttribute('aria-expanded', 'true');
                    }
                    break;
                    
                case 'ArrowDown':
                    e.preventDefault();
                    if (!wrapper.classList.contains('open')) {
                        wrapper.classList.add('open');
                        customSelect.setAttribute('aria-expanded', 'true');
                    }
                    selectedIndex = Math.min(selectedIndex + 1, options.length - 1);
                    updateHighlightedOption();
                    break;
                    
                case 'ArrowUp':
                    e.preventDefault();
                    if (!wrapper.classList.contains('open')) {
                        wrapper.classList.add('open');
                        customSelect.setAttribute('aria-expanded', 'true');
                    }
                    selectedIndex = Math.max(selectedIndex - 1, 0);
                    updateHighlightedOption();
                    break;
                    
                case 'Escape':
                    e.preventDefault();
                    wrapper.classList.remove('open');
                    customSelect.setAttribute('aria-expanded', 'false');
                    customSelect.focus();
                    break;
                    
                case 'Tab':
                    // Allow normal tab behavior
                    wrapper.classList.remove('open');
                    customSelect.setAttribute('aria-expanded', 'false');
                    break;
            }
        });
        
        function updateHighlightedOption() {
            const options = dropdown.querySelectorAll('.custom-select-option');
            options.forEach((option, index) => {
                if (index === selectedIndex) {
                    option.classList.add('highlighted');
                    option.setAttribute('aria-selected', 'true');
                    option.scrollIntoView({ block: 'nearest' });
                } else {
                    option.classList.remove('highlighted');
                    option.setAttribute('aria-selected', 'false');
                }
            });
        }
        
        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            if (!wrapper.contains(e.target)) {
                wrapper.classList.remove('open');
                customSelect.setAttribute('aria-expanded', 'false');
            }
        });
        
        // Mark as processed
        select.classList.add('custom-select-processed');
    });
});
